import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { get, getJson } from 'session';
import Modal from 'modules/common/components/Modal';
import PrintIFrame from 'modules/common/components/PrintIFrame';

function IncentiveModal({ date_from, date_to, ovrs_type }) {
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const [printLink, setPrintLink] = useState();

  const generateLink = () => {
    const url = `${
      process.env.REACT_APP_WS
    }api/v1/administrators/ovrs/mtpb/report?bearer_token=${token}&email=${_.get(
      authProfile,
      'email'
    )}&type=${ovrs_type}&date_from=${date_from}&date_to=${date_to}&output=I`;
    setPrintLink(url);
  };

  const renderFrame = () => {
    if (!_.isEmpty(date_from) && !_.isEmpty(date_to)) {
      if (!_.includes(printLink, undefined)) {
        return <PrintIFrame url={printLink} />;
      }
    }
    return null;
  };

  useEffect(() => {
    generateLink();
  }, []);

  useEffect(() => {
    generateLink();
  }, [date_from, date_to]);

  return (
    <Modal.Body>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 px-0 animated-spinner">{renderFrame()}</div>
        </div>
      </div>
    </Modal.Body>
  );
}

IncentiveModal.propTypes = {
  date_from: PropTypes.string,
  date_to: PropTypes.string,
  ovrs_type: PropTypes.string,
};

IncentiveModal.defaultProps = {
  date_from: '',
  date_to: '',
  ovrs_type: '',
};

export default IncentiveModal;
